import { render } from "./legoSearchItem.vue?vue&type=template&id=629b47f3"
import script from "./legoSearchItem.vue?vue&type=script&lang=js"
export * from "./legoSearchItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoSearchBox/legoSearchItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "629b47f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('629b47f3', __exports__)) {
    api.reload('629b47f3', __exports__)
  }
  
  module.hot.accept("./legoSearchItem.vue?vue&type=template&id=629b47f3", () => {
    api.rerender('629b47f3', render)
  })

}


export default __exports__